import { CollectionEntity } from "@busy-human/gearbox";
// import { query, where, doc } from 'firebase/firestore'
/**
 * I added a "dateNow" field that just tracks the Date.now()
 * of when the Contact Form was recieved by Firebase
 */
export var Contact;
(function (Contact) {
    function Defaults() {
        return {
            name: '',
            email: '',
            postalCode: '',
            dateNow: '',
            phone: null,
            dogInfo: null,
            message: null,
            how: null,
            intrestedInQuote: false,
            newsLetter: false,
        };
    }
    Contact.Defaults = Defaults;
    class CollectionClass extends CollectionEntity {
        relationships = {};
        defaults() {
            return Defaults();
        }
    }
    Contact.CollectionClass = CollectionClass;
    Contact.Collection = new CollectionClass({ path: '/Contact' });
})(Contact || (Contact = {}));
//# sourceMappingURL=index.js.map